import BlockTitle from "../blockTitle";
import {
  HomeController,
  useHomeContext,
} from "../../../../../../reducer/moduleReducer/home";
import React, { useEffect } from "react";
import { useNavigateTo } from "../../../../../../hooks/useNavigateTo";
import { useTranslation, getI18n } from "react-i18next";

export default function Products() {
  const { t } = useTranslation();
  const { getRecommendList, gotoProductDetail } = HomeController();
  const { state } = useHomeContext();
  const { recommendLoading, recommendList } = state;
  const navigateTo = useNavigateTo();
  const lang = getI18n().language;

  useEffect(() => {
    getRecommendList();
  }, []);

  const gotoGoodsList = () => {
    navigateTo("/goodsList");
  };

  return (
    <React.Fragment>
      {recommendList.length &&
        recommendList.map((recommend, idx) => (
          <div className={"container-center mobile text-[0px]"} key={idx}>
            <BlockTitle
              title={lang === "en" ? recommend.titleEn : recommend.title}
              labelClick={() => gotoGoodsList()}
            />
            <div className="grid grid-cols-4 mdmax:grid-cols-2 lg:gap-12 md:gap-7 mdmax:gap-4">
              {recommend.contentDetailList.map((item, i) => (
                <div
                  className="relative inline-block cursor-pointer"
                  onClick={() => gotoProductDetail(item.sourceId)}
                  key={i}
                >
                  <div className="img cursor-pointer mdmax:rounded-[12px] overflow-hidden">
                    <img
                      src={item.showPic}
                      className="container"
                      style={{ height: "250px", objectFit: "cover" }}
                    />
                  </div>
                  <div
                    className="left-0 text-left
                                  py-[24px] mdmax:py-[12px] px-[20px] mdmax:px-[5px]
                                  bottom-[32px] mdmax:bottom-[15px] w-[100%]"
                  >
                    <p className="text-lg line-clamp-1 cursor-pointer">
                      {lang === "en" ? item.detailEnName : item.detailName}
                    </p>
                    <p
                      className={
                        "text-2xl mt-[10px] mdmax:mt-[5px] text-[#999] text-[14px]"
                      }
                    >
                      ${item.price}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </React.Fragment>
  );
}
